import moment, { Moment } from "moment";

export function formatLocalDatetime(date: string | Date): Moment {
  return moment.utc(date).local();
}

export function formatDate(date: string | Date): string {
  const inputDate = moment.utc(date).local();
  if (inputDate.isSame(moment(), "day")) {
    return inputDate.format("[today at] h:mm a");
  }
  if (inputDate.isSame(moment().subtract(1, "day"), "day")) {
    return inputDate.format("[yesterday at] h:mm a");
  }
  return inputDate.format("MMM DD YYYY [at] h:mm a");
}

/** Time only, e.g. "2:05 pm" — the version-history session row's own vocabulary. */
export function formatTime(date: string | Date): string {
  return moment.utc(date).local().format("h:mm a");
}

/** A day header's own label, per `formatDate`'s today/yesterday vocabulary but without the time. */
export function formatDayHeader(date: string | Date): string {
  const inputDate = moment.utc(date).local();
  if (inputDate.isSame(moment(), "day")) return "Today";
  if (inputDate.isSame(moment().subtract(1, "day"), "day")) return "Yesterday";
  return inputDate.format("MMM DD, YYYY");
}

export function getShortDateFormat(date: string | Date): string {
  const inputDate = moment.utc(date).local();
  const today = moment();
  const minutes = today.diff(inputDate, "minutes");
  const hours = today.diff(inputDate, "hours");
  const days = today.diff(inputDate, "days");
  const months = today.diff(inputDate, "months");
  const years = today.diff(inputDate, "years");
  if (years > 0) return `${years}y`;
  if (months > 0) return `${months}mon`;
  if (days > 0) return `${days}d`;
  if (hours > 0) return `${hours}h`;
  return `${minutes}min`;
}
